export default __webpack_public_path__ + "static/lefafa_2_3-168fbe18bdebd798fd9b31331a7a962b.webp";